<template>
  <VCard class="section-card" elevation="2">
    <VCardTitle class="section-card-title">
      <slot name="section-title" />
      <VSpacer />
      <slot name="section-title-buttons" />
    </VCardTitle>
    <VDivider v-if="divider" />
    <VCardText :class="$props.cartTextCls">
      <slot name="section-content" />
    </VCardText>
    <slot name="section-actions" />
  </VCard>
</template>

<script setup>
defineProps({
  divider: {
    type: Boolean,
    default: true,
  },
  minHeight: {
    type: String,
    default: '50px',
  },
  cartTextCls: {
    type: String,
    default: '',
  },
});
</script>

<style lang="scss" scoped>
.section-card {
  border: 1px solid rgb(var(--v-theme-border));
  border-radius: 6px;
  block-size: 100%;
}

.section-card-title {
  display: flex;
  align-self: center;
  padding: 1rem;
  min-block-size: v-bind(minheight);
}
</style>
